import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m8.291,3.709c0,1.265-1.026,2.291-2.291,2.291s-2.291-1.026-2.291-2.291c0-.731.766-2.148,1.412-3.214.4-.66,1.358-.66,1.758,0,.646,1.065,1.412,2.482,1.412,3.214Zm6.698,20.291c4.632,0,8.516-2.505,9.006-7.852.06-.649-.493-1.204-1.141-1.131-4.4.498-7.866,3.823-7.866,8.983m0,0c-4.632,0-8.494-2.519-8.985-7.866-.06-.649.493-1.204,1.141-1.131,4.4.498,7.844,3.836,7.844,8.996m-3.359-9.637c.39-1.831,1.226-3.362,2.472-4.936.451-.57,1.319-.57,1.77,0,1.256,1.586,2.096,3.128,2.494,4.945-1.352.749-2.495,1.766-3.372,3.004-.874-1.242-2.015-2.261-3.364-3.013Zm-7.618,1.953c-.084-.915.246-1.81.904-2.454.653-.64,1.546-.95,2.453-.847.843.095,1.645.271,2.399.521.315-1.267.849-2.47,1.6-3.678-.71-1.115-1.949-1.859-3.369-1.859h-4c-2.209,0-4,1.791-4,4v8c0,2.209,1.791,4,4,4h4c.065,0,.126-.016.191-.019-2.361-1.684-3.873-4.34-4.178-7.664Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/spa-icon.jsx